import React from 'react';


export default function FieldShortTextViewInImport(props) {

    return (

        <div className="ui5-txt-default-small max-w-200">
            {props.value}
        </div>
    );
}